module.exports = __webpack_public_path__ + "img/ltkasia-2x.b01033f.jpg";